@switch (currentView) {
  @case (modalView.MainView) {
    <mr-modal header="We are here to help">
      <p>Please select one of the following:</p>
      <div class="button-set">
        @if (appointment?.site.helpAssist.areSchedulingTicketsAllowed) {
          <mr-button
            (click)="openTicket(modalView.AppointmentView)"
            [disabled]="!areSchedulingTicketsEnabled"
          >
            I need help with the current appointment
          </mr-button>
        }
        <mr-button
          kind="secondary"
          (click)="openTicket(modalView.GeneralView)"
          [disabled]="!areGeneralTicketsEnabled"
        >
          I need help with a general question
        </mr-button>
      </div>
      @if (!areGeneralTicketsEnabled && hasOrders) {
        <p class="navigation-description">
          @if (!areSchedulingTicketsEnabled) {
            <span>
              There is a pending request on this appointment. For questions
              regarding PO information, please contact your Buyer, Vendor, or
              Carrier.
            </span>
          } @else {
            You must enter Purchase Order(s) to proceed with creating a Help
            Assist ticket related to an appointment. For questions regarding PO
            information, please contact your Buyer, Vendor, or Carrier.
          }
          For general assistance with logging into the MR System or other How To
          questions, please call the Help Desk at
          {{ helpAssistAskUsPhoneNumber }}
        </p>
      }
      @if (!hasOrders) {
        <p class="navigation-description">
          You must enter Purchase Order(s) to proceed with creating a Help
          Assist ticket related to an appointment. For questions regarding PO
          information, please contact your Buyer, Vendor, or Carrier. For
          general assistance with logging into the MR System or other How To
          questions, please call the Help Desk at
          {{ helpAssistAskUsPhoneNumber }}.
        </p>
      }
      @if (
        areGeneralTicketsEnabled && !areSchedulingTicketsEnabled && hasOrders
      ) {
        <p>
          There is a pending request on this appointment. Please contact the
          help assist team via the general question form
        </p>
      }
    </mr-modal>
  }
  @case (modalView.GeneralView) {
    <mr-modal header="Ask Us Anything!">
      <p>Be as descriptive as possible when explaining your issue.</p>
      <mr-general-ticket-form
        [isAppointmentCreation]="isAppointmentCreation"
        [orderSearchTerms]="orderSearchTerms"
        (submitSuccess)="handleGenericSubmitSuccess($event)"
        (submitError)="handleSubmitError($event)"
      ></mr-general-ticket-form>
    </mr-modal>
  }
  @case (modalView.AppointmentView) {
    <mr-modal header="Scheduling Assistance">
      <div class="mr-layout-flex">
        <div class="mr-layout-flex__row mr-layout-flex__row--centered">
          <div class="mr-layout-flex__col mr-layout-flex__col-sm--8">
            <p>
              Can’t find a slot? Open a ticket with our scheduling specialists
              and we’ll do our best to accommodate your needs.
            </p>
          </div>
        </div>
        <div class="mr-layout-flex__row appointment-details-wrapper">
          <div class="mr-layout-flex__col mr-layout-flex__col-sm--6">
            @if (appointment) {
              <mr-ticket-appointment-details
                alignTitle="right"
                [valuesWithNoHighlight]="appointment"
              ></mr-ticket-appointment-details>
            }
          </div>
          <div class="mr-layout-flex__col mr-layout-flex__col-sm--6">
            @if (appointment) {
              <mr-ticket-po-list
                title="PO details"
                [appointment]="appointment"
              ></mr-ticket-po-list>
            }
          </div>
        </div>
        <div class="mr-layout-flex__row mr-layout-flex__row--centered">
          <div class="mr-layout-flex__col mr-layout-flex__col-sm--8">
            <mr-scheduling-ticket-form
              [appointment]="appointment"
              [appointmentId]="appointmentId"
              (submitSuccess)="handleAppointmentSubmitSuccess($event)"
              (submitError)="handleSubmitError($event)"
            ></mr-scheduling-ticket-form>
          </div>
        </div>
      </div>
    </mr-modal>
  }
}
